import { actionCreators as profileActions } from '@map/state/profile';
import { persistStoreState } from '@map/state/store';
import { actionCreators as userActions } from '@map/state/user';
import { Profile, User } from '@map/types';
import { logoutFromFacebook } from '@shared/hooks/auth/providers/facebook';
import useAction from '@shared/hooks/useAction';
import useToggleState from '@shared/hooks/useToggleState';
import mixpanel from '@shared/lib/mixpanel/mixpanel';
import axios from 'axios';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Dispatch } from 'redux';
import { buildApiUrl } from './baseApi';
import { otpLogin } from './otpUtils';

type LoginCredentials = {
  username: string;
  password: string;
  otp_attempt?: string;
};

const login = (credentials: LoginCredentials) => (dispatch: Dispatch) =>
  otpLogin<LoginCredentials, { user: User; profile: Profile }>(buildApiUrl('user_sessions'))(
    credentials,
  ).then((result) => {
    if (!result.success) {
      return result;
    }
    const { user, profile, success } = result;
    mixpanel.identify(user.id);
    dispatch(userActions.userLoggedIn(user));
    if (profile.id) {
      dispatch(profileActions.profileFetched(profile));
    }
    return { success, requestOtp: false };
  });

export const useLogin = () => useAction(login);

const logoutAction = () => (dispatch: Dispatch) =>
  axios.delete(buildApiUrl('user_sessions')).finally(() => dispatch(userActions.userLoggedOut()));

export const useLogout = () => {
  const history = useHistory();
  const logout = useAction(logoutAction);
  const [isLoading, startLoading, stopLoading] = useToggleState();
  const action = useCallback(async () => {
    try {
      startLoading();
      try {
        await logoutFromFacebook();
      } finally {
        await logout();
      }
      await persistStoreState();
      window.location.href = history.createHref({ pathname: '/' });
    } catch (ex) {
      console.warn(ex);
      stopLoading();
    }
  }, [startLoading, history, logout, stopLoading]);
  return [action, isLoading] as const;
};
